/**
 * @name: Tslandio
 * @description:._)
 * @author: mullyeux
 * @time: 2019-08-07 17:52:16
 */
import axios from 'axios'
import JoinApi from './api'

// const serverRoot = `${process.env.NODE_ENV === 'production' ? 'http://192.168.20.7:8600/duoyuan' : 'http://192.168.20.7:8600/duoyuan'}`
console.log(process.env.VUE_APP_BASE_API)
console.log(process.env.NODE_ENV)
const instance = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? '/duoyuan' : process.env.VUE_APP_BASE_API + '/duoyuan',
  baseURL: '/acknowledgment',
  timeout: 300000
})
const Http = {}

for (const key in JoinApi) {
  const api = JoinApi[key]
  Http[key] = async function (params, isFormData = false, config = {}) {
    let newParams = {}
    if (params && isFormData) {
      newParams = new FormData()
      for (const i in params) {
        newParams.append(i, params[i])
      }
    } else {
      newParams = params
    }
    let response = {}
    if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
      try {
        response = await instance[api.method](api.url, newParams, config)
      } catch (err) {
        response = err
      }
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = newParams
      try {
        response = await instance[api.method](api.url, config)
      } catch (err) {
        response = err
      }
    }
    return response
  }
}
// 请求拦截器
instance.interceptors.request.use((config) => {
  const authorization = localStorage.getItem('authorization')
  config.headers = {
    Authorization: authorization
  }
  return config
}, (error) => {
  return Promise.reject(error.response)
})
// 响应拦截器
instance.interceptors.response.use((res) => {
  return res.data
}, (error) => {
  if (error.response.status) {
    console.log(error)
    switch (error.response.status) {
      case 401:
        break
      case 403:
        break
      case 400:
        break
    }
    return Promise.reject(error.response)
  }
})

export default Http
